import { useEffect, useState } from "react";
import { WifiSlash } from "@phosphor-icons/react";

/**
 * Slim banner that appears when the browser reports no network connectivity.
 * Pairs with the service worker — cached pages will still load, API calls fall back to cache.
 */
export default function OfflineBanner() {
  const [online, setOnline] = useState(
    typeof navigator !== "undefined" ? navigator.onLine : true
  );

  useEffect(() => {
    const onOnline = () => setOnline(true);
    const onOffline = () => setOnline(false);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div
      data-testid="offline-banner"
      className="fixed top-0 left-0 right-0 z-[55] pointer-events-none"
      style={{ paddingTop: "env(safe-area-inset-top, 0px)" }}
    >
      <div className="max-w-md mx-auto px-3 pt-2 pointer-events-auto">
        <div
          className="flex items-center gap-2 rounded-xl px-3 py-2 text-xs font-semibold font-heading uppercase tracking-wide shadow-md"
          style={{ background: "#C4543C", color: "#F2EEE7" }}
        >
          <WifiSlash size={16} weight="bold" />
          <span>Offline · cached data only</span>
        </div>
      </div>
    </div>
  );
}
